import React, {Component} from 'react';
import { BASE_URL } from '../../constants/app_routes';
import {Button, Form, Input, Grid, Header, Icon, Image, Modal, Popup, Segment,Divider, Message,List} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import Loader from "../universal/loader";
import { getReportById } from '../../data/report_api';
import { REPORT_ACTIONS_API_URL } from '../../constants/api_routes';
import { checkLiability,quickChangeLiability } from '../../data/report_api';

const uuidv1 = require('uuid/v1');

class Checklist extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reportDetails:undefined,
            validChecks:[],
            itemLiabilityCheck:[],
            AIloading:false,
            liabilityCheckResponse:undefined,
            isStandard:undefined,
            isCoReport:undefined,
            CoNotesDetected:false
        }
    }
    componentDidMount() {
        getReportById(REPORT_ACTIONS_API_URL, this.props.reportDetails["id"]).then((response) =>{
     
            this.checkFields(response.report);
        });

    }


 markdownToHtml(md = "") {
  // Tables
  md = md.replace(/^\|(.+)\|\n\|([-:\s|]+)\|\n((\|.*\|\n?)*)/gm, (_, headers, aligns, rows) => {
    const headerCells = headers.split('|').map(cell => `<th>${cell.trim()}</th>`).join('');
    const rowHtml = rows.trim().split('\n').map(row => {
      const cells = row.split('|').map(cell => `<td>${cell.trim()}</td>`).join('');
      return `<tr>${cells}</tr>`;
    }).join('');
    return `<table><thead><tr>${headerCells}</tr></thead><tbody>${rowHtml}</tbody></table>`;
  });

  // Headings
  md = md.replace(/^### (.*$)/gim, '<h3>$1</h3>')
         .replace(/^## (.*$)/gim, '<h2>$1</h2>')
         .replace(/^# (.*$)/gim, '<h1>$1</h1>');

  // Bold and Italic
  md = md.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
         .replace(/\*(.*?)\*/g, '<em>$1</em>');

  // Horizontal rule
  md = md.replace(/^---$/gim, '<hr />');

  // Newlines to <br> (optional depending on your layout)
  md = md.replace(/\n/g, '<br />');

  return md;
}
 sanitizeHtml(unsafeHtml = "<br></br>") {
  const parser = new DOMParser();
  const doc = parser.parseFromString(unsafeHtml, 'text/html');

  const forbiddenTags = ['script', 'iframe', 'object', 'embed', 'link', 'style'];

  forbiddenTags.forEach(tag => {
    const elements = doc.querySelectorAll(tag);
    elements.forEach(el => el.remove());
  });

  return doc.body.innerHTML;
}

quickChangeLiability = (item, liabilityType, tcCategory = "OTHER")=>{
        let formData = new FormData()
        formData.append("client_id",  item.client_id)
        formData.append("liability",liabilityType)
        formData.append("tc_category", tcCategory)
        this.setState({reportDetails:undefined})
        quickChangeLiability(formData).then(response =>{
             getReportById(REPORT_ACTIONS_API_URL, this.props.reportDetails["id"]).then((response) =>{
     
            this.checkFields(response.report);
        });
        })
}
generateLiabilityDropdown = (item) =>{

return <Popup
  on="click"
  wide="very"
  trigger={<Button compact negative size="mini">Quick Assign Liability</Button>}
>
  <div>
    <Header>Quick Assign Liability</Header>

    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      <Button compact size="mini" onClick={() => this.quickChangeLiability(item, "Wear and Tear")}>Fair Wear and Tear</Button>
      <Button compact size="mini" onClick={() => this.quickChangeLiability(item, "Landlord Info")}>Landlord Info</Button>
      <Button compact size="mini" onClick={() => this.quickChangeLiability(item, "Tenant Cost", "OTHER")}>Tenant Cost - OTHER</Button>
      <Button compact size="mini" onClick={() => this.quickChangeLiability(item, "Tenant Cost", "CLEANING")}>Tenant Cost - CLEANING</Button>
      <Button compact size="mini" onClick={() => this.quickChangeLiability(item, "Tenant Cost", "DAMAGE")}>Tenant Cost - DAMAGE</Button>
      <Button compact size="mini" onClick={() => this.quickChangeLiability(item, "Tenant Cost", "REDECORATION")}>Tenant Cost - REDECORATION</Button>
      <Button compact size="mini" onClick={() => this.quickChangeLiability(item, "Tenant Cost", "GARDENING")}>Tenant Cost - GARDENING</Button>
    </div>

  </div>
</Popup>


}
    checkLiability  = async ( ) => {
        if(this.state.isCoReport) {
        this.setState({AIloading:true})
        let formData = new FormData()
        formData.append("report_type",  this.state.reportDetails.report_type)
        formData.append("items",JSON.stringify(this.state.itemLiabilityCheck))
        formData.append("report_id", this.state.reportDetails.id)
        let response = await checkLiability(formData)
        if (response.success) {
            this.setState({liabilityCheckResponse:response.text})
        } else {
            this.setState({liabilityCheckResponse:`ERROR - ${response.statusMessage}`})
        }
        this.setState({AIloading:false})
        }
    }

    checkFields = (reportDetails) =>{
        let isCoReport = reportDetails.inspection_type == "co"
        let isStandard = reportDetails.report_type == "standard"
        let itemLiabilityCheck = []
        let validChecks = []
        this.setState({reportDetails:reportDetails,isStandard:isStandard,isCoReport:isCoReport})


        //OTHER CHECKLIST 
        if (this.state.reportDetails.inspection_type == "co" &&  this.state.reportDetails.report_type == "other" && this.state.reportDetails.original_soc_available == true && (!this.state.reportDetails.other_template_name  || !this.state.reportDetails.other_template_date) ) {
                    let titleValCheck= {"valid":false,"text":"Checklist","reasons":["Original report stated as available in checklist, but Original Report Name and Original Report Date not set, therefore submission has been disabled. Fill in those fields or set 'Original Report Available?' to No to enable the Submit button" ]}  
                    validChecks.push(titleValCheck)            
                    }
        // TITLE IMAGE
        let titleValCheck= {"valid":true,"text":"Title Image","reasons":[]}
        if (!reportDetails.title) {
            titleValCheck["valid"] = false
            titleValCheck["reasons"].push("No Title Image Uploaded")
        }
        validChecks.push(titleValCheck)

        // KEYS
        let keyValCheck= {"valid":true,"text":"Keys","reasons":[]}

        if (reportDetails.keys.length == 0) {
            keyValCheck["valid"] = false
            keyValCheck["reasons"].push("No Keys Found")
        }
        if(isCoReport) {
            if(!reportDetails.co_keys_image) {
                keyValCheck["valid"] = false
                keyValCheck["reasons"].push("No CO Keys Image Found")
            }
        }
        else { if(!reportDetails.ci_keys_image) {
            keyValCheck["valid"] = false
            keyValCheck["reasons"].push("No CI Keys Image Found")
        }}
        validChecks.push(keyValCheck)
        //ALARMS
        let alarmValCheck= {"valid":true,"text":"Alarms","reasons":[]}
        if (reportDetails.alarms.length > 0){

            let reasons = []
            reportDetails.alarms.map((alarm, index)=>{
                if(isCoReport) {
                    if (!alarm.co_description ) {
                        alarmValCheck["valid"] = false
                        alarmValCheck["reasons"].push(`Alarm ${index + 1} without CO Description`)
                    }
                    if (!alarm.co_image ) {
                        alarmValCheck["valid"] = false
                        alarmValCheck["reasons"].push(`Alarm ${index + 1} without CO Image`)
                    }
                    if (!alarm.co_expiry ) {
                        alarmValCheck["valid"] = false
                        alarmValCheck["reasons"].push(`Alarm ${index + 1} without CO Expiry Date`)
                    }
                } else {
                    if (!alarm.ci_image ) {
                        alarmValCheck["valid"] = false
                        alarmValCheck["reasons"].push(`Alarm ${index + 1} without CI Image`)
                    }
                }
            })
        } else {
            alarmValCheck = {"valid":false,"text":"Alarms","reasons":["No Alarms Found"]}
        } 
        validChecks.push(alarmValCheck)

        // METERS
        let meterValCheck= {"valid":true,"text":"Meters","reasons":[]}
        const meters = reportDetails.meters 
        let water = false;
        let electric = false;
        let gas = false;

        for (const meter of meters) {
            const name = meter.name.toLowerCase();
            if (!water && name.includes("water")) water = true;
            if (!electric && name.includes("electric")) electric = true;
            if (!gas && name.includes("gas")) gas = true;
        }

        const missing = [];
        if (!water) missing.push("Water");
        if (!gas) missing.push("Gas");
        if (!electric) missing.push("Electricity");

        if(missing.length > 0) {
               meterValCheck["valid"] = false
            meterValCheck["reasons"].push(`The following meter types are missing: ${missing}, please add them or the reason for their absence in the meters section` )
        }
        reportDetails.meters.map(((meter) =>{
    if(meter.readings.length == 0) {
        meterValCheck["valid"] = false
        meterValCheck["reasons"].push(`No Readings Found - ${meter.name}` )}

        if(isCoReport) {
        meter.readings.map((reading, index) =>{

            if(!reading.co_value) {
                meterValCheck["valid"] = false
                meterValCheck["reasons"].push(`No CO Reading Value found for Reading ${index+1} - ${meter.name}` )
            }

            if(!reading.co_image) {
                meterValCheck["valid"] = false
                meterValCheck["reasons"].push(`No CO Reading Image found for Reading ${index+1} - ${meter.name}` )
            }
        })
    }
    }))
    validChecks.push(meterValCheck)
    
    
    
    
    //SOC 
    let socValCheck= {"valid":true,"text":"Schedule of Condition","reasons":[]}
    if(!reportDetails.soc ) {
        socValCheck= {"valid":false,"text":"Schedule of Condition","reasons":["No SOC Image Found"]}
    }
    validChecks.push(socValCheck)


    // ROOMS 

    if (reportDetails.rooms.length == 0) {
        validChecks.push({"valid":false,"text":`Rooms`,"reasons":["No Rooms Found"]})
    }
    reportDetails.rooms.map(room =>{
        let roomValCheck = {"valid":true,"text":`Room - ${room.name}`,"reasons":[]}
        if(room.images.length < 2) {
            roomValCheck["valid"] = false
            roomValCheck["reasons"].push(`Less than 2 General View Images found (${room.images.length} Present)`)
        }

        let roomItemImgCount = 0
        let itemFails = []
        room.groups.map(group =>{
            group.items.map(item => {
                roomItemImgCount += item.images.length

                if ((item.ci_notes && item.ci_notes.includes(":")) || (item.co_notes && item.co_notes.includes(":"))){
                    itemFails.push(`Possible typist timestamp not removed (":" Found ) - ${item.name} (In ${group.name})`)   
                }

                if ((item.ci_notes && item.ci_notes.includes("CO NOTES"))){
                    itemFails.push(`CI Description not updated after loading from previous Check Out ("CO NOTES" Found ) - ${item.name} (In ${group.name})`) 
                    this.setState({CoNotesDetected:true})  
                }

                if(isCoReport) {
                    if((item.co_notes && item.co_notes != "" && item.co_notes != " ") ||reportDetails.report_type == "other") {
                        itemLiabilityCheck.push({...item,flag:item.flag || "None",group_name:group.name,room_name:room.name,images:undefined})
                    }
                    if(item.co_notes && item.co_notes != "" && item.co_notes != " ") {
                        if(!item.flag || (item.flag && item.flag == "None")) {
                            roomValCheck["valid"] = false
                            itemFails.push(<span>No Liability Flag set or set as "None" for Item  <strong>{item.name}</strong> (In <strong>{group.name}</strong> with CO Note <strong>{item.co_notes}</strong>) {this.generateLiabilityDropdown(item)}</span>)   
                        }
                        if(item.images.length == 0) {
                            roomValCheck["valid"] = false
                            itemFails.push(`No photos added for Item with dilapidation comment. Always add at least one photo for an item with a dilapidation comment - ${item.name} (In ${group.name})`)  
                            
                        }
                    }
                }
            })
        })
        if(roomItemImgCount < 6) {
            roomValCheck["valid"] = false
            roomValCheck["reasons"].push(`Less than 6 Item Images found (${roomItemImgCount} Present)`)   
        }
        roomValCheck["reasons"].push(...itemFails)

        validChecks.push(roomValCheck)
    })

    // Setstate
    this.setState({validChecks:validChecks,itemLiabilityCheck:itemLiabilityCheck},()=>{
    })
}
    render() {
        return (<Segment>
            <Modal size="large" open={this.props.showChecklist} onClose={(e) => {
            }}><Modal.Header>Report Completion Checklist</Modal.Header>
            <Modal.Content style={{paddingTop: '0'}}>
                <div className="modal-close-button">
                    <Button basic icon negative onClick={(e) => {
                        this.props.handleClose();
                    }}><Icon name="close"/></Button>
                </div>
                    <Modal.Description>
                  <Segment>
                  {this.props.reportUpdates.rooms.length +this.props.reportUpdates.groups.length +this.props.reportUpdates.items.length > 0 &&<Message icon negative><Icon name='exclamation'  /><Message.Content><Message.Header>You have unsaved changes to the report</Message.Header>Please save your changes before completing the checklist</Message.Content></Message>}
  {!this.state.reportDetails &&   <Message icon>
    <Icon name='circle notched' loading />
    <Message.Content>
      <Message.Header>Loading Report Details</Message.Header>
    </Message.Content>
  </Message>}
  {this.props.reportDetails && this.state.reportDetails && <React.Fragment>
    <Segment>
    <Message
    header='A Final Check'
    content='Please try to address all points that have been flagged, as much as possible, before submitting the report.'
  />
  {this.state.isCoReport && <Message><Message.Header>Note regarding Quick Assign buttons on this window</Message.Header>Please note any liability changes done using the Quick Assign buttons on this page will not be correctly displayed on the report builder if this popup is closed, until the page is refreshed.</Message>}
   { this.state.isCoReport && <Message>
        <Message.Header>AI Liability Check (BETA) <Popup wide="very" content={<div><Header>AI Liability Commentary</Header><span>This experimental feature feeds the items for which you have added check out notes for into AI who will provide a comment on your liability assignments and recommend possible changes where it deems appropriate based on the information available to it, you can use this as a second opinion but do not need to take its commentaries as 100% correct.</span></div>}trigger={<Button primary icon circular basic compact size="mini"><Icon name="question"></Icon></Button>}></Popup> {!this.state.liabilityCheckResponse &&<Button compact onClick={this.checkLiability} loading={this.state.AIloading}>Check Liability</Button>}</Message.Header>
         <Message.Content
        dangerouslySetInnerHTML={{
          __html: this.sanitizeHtml(this.markdownToHtml(this.state.liabilityCheckResponse)),
        }}
      />
        </Message>}
        <Divider/>
        {this.props.userRole == "clerk" && <div style={{textAlign:"center"}}>
        <Button disabled={
            (this.state.reportDetails.inspection_type == "co" &&  this.state.reportDetails.report_type == "other" && this.state.reportDetails.original_soc_available == true && (!this.state.reportDetails.other_template_name  || !this.state.reportDetails.other_template_date) )
            ||(this.state.CoNotesDetected && this.state.reportDetails.inspection_type != "co")}  primary onClick={()=>{this.props.completeReport()}}>Submit Report</Button>
       {this.state.CoNotesDetected &&  this.state.reportDetails.inspection_type != "co" && <Message danger negative><Message.Header>Report Submission Disabled</Message.Header>Report Submission has been disabled because there are still "CO NOTES - " that have not been removed after loading the previous report, check the list for which items contain this and update them, save the report, and try again</Message>}
    </div>}
    </Segment>
        <Segment >
            {this.state.reportDetails.inspection_type == "co" && <Message warning header="Additional Tenant Costs" content="Have you added any missing keys, poor odours and items left behind by the tenant as a Tenant Cost via the flag icon?"></Message> } 
     {this.state.validChecks.map(checkObj =>{
        return <Message  negative={!checkObj["valid"]}positive={checkObj["valid"]}>
            <Message.Header><Icon name={checkObj["valid"]?'check':"exclamation"}  />{checkObj["text"]}</Message.Header>
            <Message.List>
                {checkObj["reasons"].map(reason =>{
                    return <Message.Item>{reason}</Message.Item>
                })}
            </Message.List>
        </Message> 
     })}
      </Segment>
    </React.Fragment>}
    
                </Segment>
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>);
    }

}

export default ReportContainer(Checklist);


// WEBPACK FOOTER //
// ./src/views/report/checklist.js